(function () {
  'use strict';

  var root = document.documentElement;
  root.classList.add('nyalisis-js');

  function revealWithin(scope) {
    var items = (scope || document).querySelectorAll('[data-nyalisis-reveal], .nyalisis-reveal');

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.08 }
    );

    items.forEach(function (item) {
      if (!item.classList.contains('is-visible')) observer.observe(item);
    });
  }

  function updateHeaderState() {
    document.body.classList.toggle('nyalisis-page-scrolled', window.scrollY > 12);
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      updateHeaderState();
      ticking = false;
    });
  }

  function initialize() {
    revealWithin(document);
    updateHeaderState();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', function (event) {
    revealWithin(event.target);
  });
})();
